import GTMService from "../services/GTMService";
import store from "../store/store";
import enumScreenView from "./enumScreenView";
import enumInteraction from "./enumInteraction";
import enumNonInteraction from "./enumNonInteraction";


export default class Tools{

    static setErrorGmt(blocker,docType,desc,errorNumber)
    {
        if(errorNumber === 4) {
            desc = 'algo-deu-errado-tente-de-novo';
        }
        // aqui vamos tratar o erro e criar o enum para a funcao saber quem vai chamar
        return `${docType}_error&${blocker}&${desc}_documentError${errorNumber}`;
    }

    static sanitize(string){
        return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]/gi, '')
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
                return index === 0 ? word.toLowerCase() : word.toLowerCase();
            }).replace(/\s+/g, '-');
    }

    /**
     * @return screen view da tela anterior
     * */
    static makeHistoryScreenNameDocument(typeDocument,errorNumber,side)
    {
        let pageName = '';
        let frontOrBack = (side)  ? 'front-picture' : 'back-picture';
        switch (typeDocument) {
            case "CNH":
                pageName = '/drivers-license/'+ frontOrBack +'/doc/document-error-'+ errorNumber;
                break;
            case 'RG':
                pageName = '/id-card/'+ frontOrBack +'/doc/document-error-'+ errorNumber;
                break;
            default :
                pageName = '/other-documents/'+ frontOrBack +'/doc/document-error-'+ errorNumber;
        }

        return pageName;

    }
}



// WEBPACK FOOTER //
// ./src/utils/Tools.js